import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  iconArrowDown: {
    margin: '0 auto',
    transition: 'transform 0.4s ease-in-out',
    cursor: 'pointer',
    color: '#242424',
    '& svg': {
      width: 25,
      height: 30,
      marginRight: 10
    },

    '&.chevronUp': {
      transform: 'rotate(-180deg)'
    },

    '&.chevronDown': {
      transform: 'rotate(0deg)'
    }
  }
});
